import { render, staticRenderFns } from "./NewsPage.vue?vue&type=template&id=1de1ef76&scoped=true&"
import script from "./NewsPage.vue?vue&type=script&lang=js&"
export * from "./NewsPage.vue?vue&type=script&lang=js&"
import style0 from "./NewsPage.vue?vue&type=style&index=0&id=1de1ef76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de1ef76",
  null
  
)

export default component.exports